<template>
  <div class="exam-uniform-schedule-wrap"
       :style="themeVars">
    <div class="header">
      <el-radio-group v-model="active"
                      size="mini">
        <el-radio-button v-for="tab in tabs"
                         :key="tab.value"
                         :label="tab.value">{{tab.label}}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="body">
      <div class="body-cont">
        <keep-alive>
          <component v-if="current"
                     :is="current.component"
                     v-bind="$attrs"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import Theme from '../../../../../../../mixins/theme'
import ExamUniformScheduleStudent from './student'
import ExamUniformScheduleRoom from './room'
import ExamUniformScheduleArrange from './arrange'
export default {
  name: 'ExamUniformScheduleWrap',
  mixins: [Theme],
  data () {
    return {
      tabs: [{
        label: '考试学生',
        value: 'student',
        component: ExamUniformScheduleStudent
      }, {
        label: '考场管理',
        value: 'room',
        component: ExamUniformScheduleRoom
      }, {
        label: '编排结果',
        value: 'arrange',
        component: ExamUniformScheduleArrange
      }],
      active: ''
    }
  },
  computed: {
    current () {
      return this.tabs.find(tab => tab.value === this.active)
    }
  },
  created () {
    this.active = this.tabs[0].value
  }
}
</script>

<style lang="scss">
  .exam-uniform-schedule-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 0 15px;
      background-color: #fff;
      border-bottom: 1px solid #ebeef5;
      .el-radio-group {
        .el-radio-button {
          &.is-active {
            &:after {
              content: '';
              position: absolute;
              right: 0;
              bottom: 0;
              left: 0;
              height: 3px;
              background-color: var(--theme-color);
            }
            .el-radio-button__inner {
              color: var(--theme-color);
            }
          }
          & + .el-radio-button {
            margin-left: 50px;
          }
          .el-radio-button__inner {
            position: relative;
            color: #303133;
            font-size: 12px;
            padding: 8px 0 12px;
            background-color: transparent;
            border: none;
            box-shadow: none;
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        inset: 0;
      }
    }
  }
</style>
